//import {SiAdobexd} from 'react-icons/si'
import { RiAdminFill } from "react-icons/ri"
//import {RiReactjsLine} from 'react-icons/ri'
import { FaCloud } from "react-icons/fa"
import {FaServer} from 'react-icons/fa'
import {AiFillAppstore} from 'react-icons/ai'
import { MdEngineering } from "react-icons/md"


const data = [
    {
        id: 1, icon: <RiAdminFill/>, title: 'DevOps Engineering', desc: "DevOps is a set of practices that unifies software development and IT operations, emphasizing collaboration, automation, and continuous delivery to streamline the development lifecycle for your web app."
    },
    {
        id: 2, icon: <FaCloud/>, title: 'AWS and GCP Cloud Computing', desc: "Cloud computing is the delivery of computing services over the internet, offering on-demand access to resources like servers, storage, and applications, enabling scalable and flexible IT solutions."
    },
    {
        id: 3, icon: <FaServer/>, title: 'Python Backend Development', desc: "The security of your business/product is taken seriously right from the start of the project. I will build a strong backend and make sure your website/app is secure from attacks."
    },
    {
        id: 4, icon: <AiFillAppstore/>, title: 'Agile Supporting for App developpment', desc: 'Agile (Scrum) support involves facilitating and advocating for the Scrum framework, emphasizing collaboration, adaptability, and iterative development to deliver valuable software increments efficiently.'
    } ,
    {
        id: 5, icon: <MdEngineering/>, title: 'MLOPS Engineering', desc: 'MLOps Engineers focus on implementing and maintaining robust Machine Learning Operations practices, ensuring seamless integration of machine learning models into the software development lifecycle, emphasizing automation, monitoring, and collaboration between data scientists and IT operations.'
    }
]


export default data